import {axis, dataMultiAxisChart} from '../types/multiAxisChart';
import {meses} from '../consts/meses';
import {EstadoProductosAnual} from 'src/views/dashboard/bussines/entities/EstadisticasCRM.entity';

type fnMapperEstadoProductoToDataMultiChar = (params: {
   data: EstadoProductosAnual[];
}) => dataMultiAxisChart[];

export const mapperEstadoProductoToDataMultiChar: fnMapperEstadoProductoToDataMultiChar = ({
   data
}) => {
   // Agrupar los datos por mes
   const mesesAgrupados = data.reduce((acc, {mes, estado, nroProductos}) => {
      acc[mes] = acc[mes] || [];
      acc[mes].push({codigo: estado, denominacion: estado, value: nroProductos});
      return acc;
   }, {} as Record<number, axis[]>);

   // Procesamiento de los datos agrupados por mes
   let activos = 0;
   let datos: dataMultiAxisChart[] = [];

   for (const [mesStr, estados] of Object.entries(mesesAgrupados)) {
      const mes = Number(mesStr);
      // Acumulador para la suma de valores de los estados
      let nuevos = 0;
      let inactivos = 0;

      for (const estadoInfo of estados) {
         if (estadoInfo.denominacion === 'nuevo') {
            nuevos = estadoInfo.value;
         } else {
            inactivos = estadoInfo.value;
         }
      }

      // Si es mes 0, tomamos el valor inicial de "activos"
      if (mes === 0) {
         activos = estados[0]?.value || 0;
      } else {
         // Agregar los datos procesados al array final
         datos.push({
            codigo: mesStr,
            denominacion: meses[mes - 1].labelLong, // Nombre completo del mes
            mark: meses[mes - 1].label, // Abreviatura del mes
            axis: [...estados, {codigo: 'activo', denominacion: 'activo', value: activos}] // Subcategorías por mes
         });
         // Calcular el total de activos
         activos = activos + nuevos - inactivos;
      }
   }

   return datos;
};
